import { AppBar, Avatar } from '@coolblue-development/becky';
import ProfileMenu from './ProfileMenu';
import CatoLogo from './CatoLogo';
import StatusMenu from './StatusMenu';
import Username from './UserDetails';
import { useAppContext } from '../../../AppContext';
import GenerateChatButton from '../Util/GenerateChatButton';
import config from '../../../config';

export interface HeaderProps {
  instanceUrl: string;
}

const Header: React.FC<HeaderProps> = ({ instanceUrl }) => {
  const { agent } = useAppContext();
  const { environment } = config;
  const isTestingEnv = environment === 'development' || environment === 'testing';

  return (
    <AppBar
      sx={{ zIndex: 2, position: 'relative', '& p:not(:empty)': { marginBottom: '0' }, backgroundColor: '#357F35' }}
      elevation={0}
      variant="outlined"
      position="static"
      logo={<CatoLogo />}
      title="Cato"
      actions={
        <>
          {isTestingEnv && <GenerateChatButton isPersistent={true} />}
          {isTestingEnv && <GenerateChatButton />}
          <StatusMenu />
          <Username name={agent?.getName() ?? ''} />
        </>
      }
      avatar={
        <Avatar>
          <ProfileMenu instanceUrl={instanceUrl} />
        </Avatar>
      }
    />
  );
};

export default Header;
